<template>
    <div class="company-crm-wrapper">
        <Sidebar @navigateTo="switchTab"></Sidebar>
        <SchoolMatrix v-if="selected_tab == 'school_partners'">
        </SchoolMatrix>
        <Lia v-if="selected_tab == 'lia'"></Lia>
    </div>
</template>
<script>
import Sidebar from "@/views/crm/components/sidebar.vue";
import SchoolMatrix from "@/views/crm/tabs/Matrix/index.vue";
import Lia from "@/views/crm/tabs/Lia/index.vue";
export default {
    name: "crm-wrapper",
    props: {

    },
    components: {
        Sidebar,
        SchoolMatrix,
        Lia,
    },
    data() {
        return {
            selected_tab: "search",
        };
    },
    computed: {},
    watch: {},
    mounted() {
        let vm = this;
        vm.selected_tab = vm.$route.params.tab || "school_partners";
    },
    methods: {
        switchTab(tab) {
            let vm = this;
            vm.selected_tab = tab.name;
            vm.$router.push({
                params: {
                    tab: tab.name
                }
            });
        }
    },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.company-crm-wrapper {
    background: #fff;
    min-height: 500px;
    width: 100%;
    display: flex;
    position: fixed;
    top: 55px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    z-index: 9999;

}
</style>